import * as React from "react";
const CommunicationActive = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="iconmonstr-smartphone-13 1" clipPath="url(#clip0_940_162144)">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8235 28H2.33333C1.04533 28 0 26.9547 0 25.6667V2.33333C0 1.04533 1.04533 0 2.33333 0H18.6667C19.9547 0 21 1.04533 21 2.33333V7H18.6667V3.5H2.33333V23.3333H15.1667V26.25C15.1667 26.8613 15.379 27.6208 15.8235 28ZM26.25 8.16667C27.216 8.16667 28 8.95067 28 9.91667V26.25C28 27.2137 27.2172 28 26.25 28H18.0833C17.1162 28 16.3333 27.2125 16.3333 26.25V9.91667C16.3333 8.95183 17.1185 8.16667 18.0833 8.16667H26.25ZM10.5 24.5C11.144 24.5 11.6667 25.0227 11.6667 25.6667C11.6667 26.3107 11.144 26.8333 10.5 26.8333C9.856 26.8333 9.33333 26.3107 9.33333 25.6667C9.33333 25.0227 9.856 24.5 10.5 24.5ZM22.1667 26.8333C21.5215 26.8333 21 26.3107 21 25.6667C21 25.0227 21.5215 24.5 22.1667 24.5C22.8107 24.5 23.3322 25.0227 23.3322 25.6667C23.3322 26.3107 22.8107 26.8333 22.1667 26.8333ZM26.8333 23.3333V11.6387H17.5V23.3333H26.8333ZM22.75 10.5C23.0708 10.5 23.3333 10.2387 23.3333 9.91667C23.3333 9.59467 23.0708 9.33333 22.75 9.33333H21.5833C21.2613 9.33333 21 9.59467 21 9.91667C21 10.2387 21.2613 10.5 21.5833 10.5H22.75Z"
        fill="url(#paint0_linear_940_162144)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_940_162144"
        x1={14}
        y1={0}
        x2={14}
        y2={28}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB258" />
        <stop offset={1} stopColor="#1AB3FF" />
      </linearGradient>
      <clipPath id="clip0_940_162144">
        <rect width={28} height={28} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CommunicationActive;
